import { useCallback } from 'react';
import { Field as FinalField } from 'react-final-form';
import { get } from 'lodash';
import { RadioGroup } from '@lendi-ui/radio';

import { CONVEYANCING_OPTIONS, FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { ConveyancingPrice } from '@funnels/types';
import { FieldLabel } from '@funnels/ui-components';
import { validateNotEmpty } from '@funnels/utils';

import { StyledField, StyledRadioGroup } from './style';

interface ConveyancingOptionsViewProps {
  conveyancingFee?: ConveyancingPrice;
  onChange?: (selectedValue?: string) => void;
  isOptional?: boolean;
}

export function ConveyancingOptions({ conveyancingFee, onChange, isOptional = false }: ConveyancingOptionsViewProps) {
  const [formValues, setFormValue] = useFormValues();

  const selectConveyancing = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedValue = e.target.value;
      setFormValue(FIELD_PATHS.CONVEYANCING_INTENT, selectedValue);
      if (onChange) onChange(selectedValue);
    },
    [onChange, setFormValue]
  );

  if (!conveyancingFee) {
    return null;
  }

  const selectedOption = get(formValues, FIELD_PATHS.CONVEYANCING_INTENT, '');
  const validate = (value: any) => {
    return validateNotEmpty('Please select an option.', isOptional)(value);
  };

  return (
    <>
      <FieldLabel
        label={'Does your customer want to include conveyancing and legal services in this purchase?'}
        isOptional={isOptional}
      />
      <FinalField name={FIELD_PATHS.CONVEYANCING_INTENT} validate={validate}>
        {({ input, meta }) => (
          <StyledField {...meta} error={meta.error}>
            <StyledRadioGroup size="sm" onChange={selectConveyancing} selectedValue={selectedOption}>
              {CONVEYANCING_OPTIONS.map((option) => (
                <RadioGroup.Radio key={`${option.value}`} label={option.label} value={option.value} />
              ))}
            </StyledRadioGroup>
          </StyledField>
        )}
      </FinalField>
    </>
  );
}
